export const ERROR_ROUTE = '/error';
export const MAIN_PAGE_ROUTE = '/';
